import { render, staticRenderFns } from "./attributeEdit.vue?vue&type=template&id=1be0512c&scoped=true&"
import script from "./attributeEdit.vue?vue&type=script&lang=js&"
export * from "./attributeEdit.vue?vue&type=script&lang=js&"
import style0 from "./attributeEdit.vue?vue&type=style&index=0&id=1be0512c&prod&scoped=true&lang=less&"
import style1 from "./attributeEdit.vue?vue&type=style&index=1&id=1be0512c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be0512c",
  null
  
)

export default component.exports